import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthTokenService } from './auth-token.service';

export const tokenGuard: CanActivateFn = () => {
    const auth = inject(AuthTokenService);
    const router = inject(Router);
    return auth.token ? true : router.createUrlTree(['/missing-token']);
};
